import React, { useEffect, useState } from "react";
import { Loading } from "../generals/Loading";
import { LPTableSmall } from "./LPTableSmall";
import { fetchData } from "../../helpers/getData/fetchData";
import { useTranslation } from "react-i18next";

const LPTableSmallWrapper = ({ fundId, percentage, generalSheet }) => {
  const { t } = useTranslation("global");
  const [distributionList, setDistributionList] = useState("isLoading");

  useEffect(() => {
    fetchData(setDistributionList, `/fundDistributions?id=${fundId}`, t);
  }, [t, fundId]);

  if (distributionList === "isLoading") return <Loading />;

  return (
    <LPTableSmall
      percentage={percentage}
      generalSheet={generalSheet}
      distributionList={distributionList}
    />
  );
};

export default LPTableSmallWrapper;
